import { LoadingCirculo } from "components/LoadingCirculo";
import { Container } from "./style";
import { useEffect, useState } from "react";
import { formatarDinheiro } from "_utils/Money";
import { IEstatisticasLotePagamentoAprovado } from "../../../../interface/IEstatisticasLotePagamentoAprovado";

interface IProps {
  item: "qtdProcessos" | "totalPagarFornecedor";
  id: number;
  estatisticasLotesPagamento: IEstatisticasLotePagamentoAprovado[];
}

export function LoadingEstatisticaLote({
  item,
  id,
  estatisticasLotesPagamento,
}: IProps) {
  const [valorMostrar, setValorMostrar] = useState<any>(null);

  useEffect(() => {
    const processoValor = estatisticasLotesPagamento.find(
      (item) => item.idLote == id
    )?.[item];

    if (processoValor) {
      setValorMostrar(
        item == "qtdProcessos"
          ? processoValor
          : formatarDinheiro(Number(processoValor))
      );
      return;
    }

    setValorMostrar(estatisticasLotesPagamento ? "-" : null);
  }, [estatisticasLotesPagamento]);

  return (
    <Container>
      {valorMostrar ?? <LoadingCirculo mostrar height={1.5} />}
    </Container>
  );
}
